<res-generic-grid [gridName]="gridName" [automationId]="automationId" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [helpIndex]="helpIndex" [headerTemplate]="headerTemplate"
    [columnDefs]="columnDefs" [requestInfo]="requestInfo" [pagerVisible]="false"
    [cellClickedCallback]="cellClickedCallback" [responseArrayCallback]="responseArrayCallbackRealmNodes"
    [responseCallback]="responseCallback" [gridContext]="gridContext" [customGridClass]="'ag-no-odd-but-even-rows'"
    [rowHeight]="50">
</res-generic-grid>

<ng-template #headerTemplate>
    <div *ngIf="hasRealmNodesAddEditPermissions" class='parent-header'>
        <button type="button" data-automation-id="realm-nodes-add-new-realm-node-button" class="secondary-button"
            (click)="addNewRealmNode()">
            <i class="fa fa-plus"></i>{{newRealmNodeBtn}}
        </button>
        <button type="button" data-automation-id="realm-nodes-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isDisabled()">Save</button>
        <button type="button" data-automation-id="realm-nodes-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" [disabled]="isDisabled()">Discard Changes</button>
    </div>
</ng-template>